import { Text } from '@audio-network/componentlibrary'
import { NewTab, Queue } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import Image from 'next/image'
import { Suspense } from 'react'

import optimizeContentfulImage from '@/utils/contentful/optimizeContentfulImage'

import styles from './AutocompleteItem.module.css'
import { AutocompleteItemProps } from './AutocompleteItem.types'

const THUMBNAIL_SIZE = 40

const FallbackThumbnail = (): JSX.Element => {
	return (
		<div className={styles.thumbnailPlaceholder}>
			<Queue size="medium" />
		</div>
	)
}

const AutocompleteItem: React.FC<AutocompleteItemProps> = ({
	className,
	icon,
	image,
	title,
	subtitle,
	pageUrl,
	...props
}) => {
	return (
		<div className={clsx(styles.container, className)} {...props}>
			{image ? (
				<div className={styles.imageContainer}>
					{image.src ? (
						<Suspense fallback={<FallbackThumbnail />}>
							<Image
								src={optimizeContentfulImage(image.src, {
									width: THUMBNAIL_SIZE,
									height: THUMBNAIL_SIZE,
								})}
								alt={image.alt}
								width={THUMBNAIL_SIZE}
								height={THUMBNAIL_SIZE}
							/>
						</Suspense>
					) : (
						<FallbackThumbnail />
					)}
				</div>
			) : (
				<div className={styles.iconContainer}>{icon}</div>
			)}
			<span className={styles.text}>
				<Text variant="bodyM">{title}</Text>
				{subtitle && (
					<Text variant="bodyS" className={styles.secondaryText}>
						{subtitle}
					</Text>
				)}
			</span>
			{pageUrl && <NewTab />}
		</div>
	)
}

export default AutocompleteItem
